import { create } from "zustand";

interface HeaderCloseBtnState {
  isVisible: boolean;
  modalCloseCallback: () => void;
  showHeaderCloseBtn: (modalCloseCallback: HeaderCloseBtnState["modalCloseCallback"]) => void;
  hideHeaderCloseBtn: () => void;
}

export const useHeaderCloseBtnStore = create<HeaderCloseBtnState>((set, get, api) => ({
  isVisible: false,
  modalCloseCallback: () => {},
  showHeaderCloseBtn: (modalCloseCallback) =>
    set(() => ({
      isVisible: true,
      modalCloseCallback,
    })),
  hideHeaderCloseBtn: () => {
    get().modalCloseCallback();
    set({ isVisible: false, modalCloseCallback: () => {} })
  },
}));

export const showHeaderCloseBtn = (onCloseCallback: HeaderCloseBtnState['modalCloseCallback']) => {
  useHeaderCloseBtnStore.getState().showHeaderCloseBtn(onCloseCallback);
};

export const hideHeaderCloseBtn = () => {
  useHeaderCloseBtnStore.getState().hideHeaderCloseBtn();
};